import { render, staticRenderFns } from "./DefaultLanguageForm.vue?vue&type=template&id=b7d2019e&scoped=true"
import script from "./DefaultLanguageForm.vue?vue&type=script&lang=js"
export * from "./DefaultLanguageForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7d2019e",
  null
  
)

export default component.exports